/**
 * This is a helper class for sending google analytics events for the search experience
 * This is a wrapper for the GtmService. Do not call GTM or GA directly but use the GtmService.
 * Events tracked by this file set all GA categories to "Search" to namespace events
 */
import GtmService from 'static/script/app/ui/google-tagmanager-service';

const GA_EVENT_SEARCH_CATEGORY = 'Search';

const filterNameMappings = {
    itemCondition: 'Condition',
    itemType: 'Ad Format',
    sellerType: 'Seller Type',
    county: 'Geo - Selected',
    countyBox: 'Geo',
    itemStatus: 'Item Status',
    shoeTypes: 'Type',
    subDepartments: 'Department',
    shoeSizes: 'Size',
    brandTags: 'Brand',
    sortBy: 'Sorting',
    price: 'Price',
    Layout: 'Layout',
    categorySelected: 'Category - Selected',
    categoryHorizontalSelected: 'Category - Hrz nav - Selected'
};

/**
 * Generic action tracker for things that happen in the Search.
 * @param {string} action
 * @param {string} label
 */
export const trackAction = (action, label) => {
    GtmService.trackAction(GA_EVENT_SEARCH_CATEGORY, action, label);
};

const getFilterLabel = key => {
    if (key in filterNameMappings) {
        return filterNameMappings[key];
    } else {
        return key;
    }
};

/**
 * translates the tech names of the filters to ga friendly names. to see the techie names a filter has
 * see the URL paramters on a search or a browse page.
 * @param {string} filter the name of the filter
 * @param {string} value the value the filter gets
 */
export const trackFilter = (filter, value) => {
    let action = getFilterLabel(filter);
    trackAction(`Filter ${action}`, value);
};

export const trackNavigation = label => {
    trackAction('Navigation', label);
};

export const trackAccordion = filter => {
    let action = getFilterLabel(filter);
    trackAction('Filter box - Open/Close', action);
};

export const trackButton = label => {
    trackAction('Button', label);
};

export const trackLink = (action, label) => {
    trackAction(`Link - ${action}`, label);
};

export const trackPriceFilter = (fromPrice, toPrice) => {
    if (fromPrice === '1') {
        fromPrice = undefined;
    }

    // get a label that represents the current selected value
    let lbl = [];
    if (typeof fromPrice !== 'undefined') {
        lbl.push('Min set');
    }
    if (typeof toPrice !== 'undefined') {
        lbl.push('Max set');
    }
    if (lbl.length === 0) {
        lbl.push('All');
    }
    trackAction(`Filter Price`, lbl.join(' and '));
};

/**
 * Tracks to google tag manager that a new search was made
 * @param {object} searchResults data returned fromm ajax when doing a search or browsing.
 * Note: needs to be the normalized version.
 */
export const trackNewSearch = (categoryPath, items, metaTitle) => {
    if (typeof categoryPath === 'undefined' || categoryPath.length == 0) {
        return;
    }

    let reverseCategoryPath = categoryPath
        .filter(c => c.id > 0)
        .map(c => c.name)
        .reverse();

    GtmService.trackGtmEvent('viewCategory', {
        category: reverseCategoryPath.join(' > ')
    });

    GtmService.push({
        'page.content-group-2': reverseCategoryPath.slice(0, 3).join(' > '),
        categoryId: categoryPath.length > 0 ? categoryPath[0].id : null
    });

    if (items && items.length >= 3) {
        GtmService.trackGtmEvent('viewItems', {
            itemIds: items.slice(0, 3),
            keywords: categoryPath[0].name
        });
    }

    GtmService.push({
        ga_page_title: metaTitle
    });
};
